import React from "react";
import {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {
    Alert, Button,
    Card, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, Grid,
    IconButton,
    Snackbar, Typography
} from "@mui/material";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import styles from "../../../assets/css/page.module.scss";
import CustomTable from "../../../components/subComponents/Table";
import Pagination from "../../../components/subComponents/Pagination";
import {CoWorkApi} from "../../../utils/CoWorkApi";

const CoWork = (props) => {
    const params = useParams();
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [openSnackBar1, setOpenSnackBar1] = useState(false);
    const [message, setMessage] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [name, setName] = useState("");
    const [age, setAge] = useState("");
    const [height, setHeight] = useState("");
    const [city, setCity] = useState("");
    const [mail, setMail] = useState("");
    const [phone, setPhone] = useState("");
    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const handleClickSnackBar1 = (text) => {
        setOpenSnackBar1(true);
        setMessage(text);
    };
    const handleClose = () => {
        setOpenDialog(false);
    };
    const handleCloseSnackBar1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar1(false);
    };


    const deleteCoWork = async (id) => {
        setDataLoading(true);
        await CoWorkApi.deleteCoWork(id, () => {
            handleClickSnackBar1('درخواست همکاری حذف شد!');
            fetchData(page);

        }, () => {
        });
    }
    const fetchData = async (page) => {
        setDataLoading(true);
        await CoWorkApi.getAllCoWork(page,
            (result) => {
                setRows(result.data.data);
                let pC = Math.floor(parseInt(result.data.count) / 10);
                if (parseInt(result.data.count) % 10)
                    pC++;
                setPageCount(pC);
                setDataLoading(false);
                setPage(page);
            },
            (error) => {
                setDataLoading(false);

            });

    }
    const headers = [
        {
            field: 'title', title: 'نام', width: 250, renderCell: (row) => (
                <div>
                    <Link to={`/admin/co-work/${row.id}`}>{row.name}</Link>
                </div>
            ),
        },


        {
            field: 'userStatus', title: '---', width: 200,
            align: 'right',
            renderCell: (row) => (
                <>
                    <IconButton color="error" component="button" onClick={() => {
                        (async () => {
                            await deleteCoWork(row.id);
                        })();
                    }}>
                        <DeleteOutlineRoundedIcon/>
                    </IconButton>

                </>)
        },


    ];

    const getContract = async (id) => {
        await CoWorkApi.getCoWork(id, (result) => {
            setName(result.data.name);
            setMail(result.data.mail);
            setPhone(result.data.phone);
            setAge(result.data.age);
            setHeight(result.data.height);
            setCity(result.data.city.name);

        }, (error) => {
        })
    }

    useEffect(() => {
        (async () => {
            await fetchData(1);
        })();


    }, []);
    useEffect(() => {
        if (params.id) {
            (async () => {
                await getContract(params.id);
            })();
        }
    }, [params.id]);

    return <div style={{padding: 15}}>
        <Card elevation={3} style={{height: 'calc(100vh - 30px)', direction: "rtl", overflow: "hidden"}}>
            <div className={styles.container}>
                <CustomTable headers={headers} rows={rows} loading={dataLoading} bottom={160}/>
                <div className={styles.bottomBar}>

                    <Pagination
                        // className={classes.root}
                        color="primary"
                        count={pageCount}
                        page={page}
                        onChange={(event, value) => {
                            (async () => {
                                await fetchData(value);
                            })();
                        }}
                    />
                </div>
            </div>
        </Card>
        <Dialog
            fullWidth
            maxWidth={"md"}
            open={(openDialog || params.id)}
            onClose={handleClose}
        >
            <DialogTitle>شرح درخواست</DialogTitle>
            <DialogContent>
                <DialogContentText>
                </DialogContentText>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant={"body1"}>
                            نام :{name}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant={"body1"}>
                            شماره تماس :{phone}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant={"body1"}>
                            پست الکترونیکی :{mail}
                        </Typography>
                    </Grid><Grid item xs={12}>

                </Grid>


                </Grid>


            </DialogContent>
            <DialogActions>
                <Button color="error" onClick={() => {
                    if (params.id)
                        navigate(-1);
                    else handleClose();
                }}>
                    انصراف
                </Button>

            </DialogActions>
        </Dialog>
        <Snackbar open={openSnackBar1} autoHideDuration={2000}
                  onClose={handleCloseSnackBar1}
                  className={styles.snackBar}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        >
            <Alert
                severity="success"
                className={styles.txt}
            >
                {message}
            </Alert>
        </Snackbar>

    </div>;
}

export default CoWork;